import React, { useEffect, useRef, useState } from "react";
import ErrorBoundary from "../../../../components/error-boundary";
import ComponentViewFallback from "../../../../components/error-boundary/fallback/ComponentViewFallback";
import { Table } from "reactstrap";
import { AiOutlineReload } from "react-icons/ai";
import { LuDatabaseBackup } from "react-icons/lu";
import ChecklistTable from "../../../../components/table/checklisttable/ChecklistTable";
import BusinessTable from "../../../../components/table/all-tables/checklisttable/BusinessTable";
import OwnersTable from "../../../../components/table/all-tables/checklisttable/OwnersTable";
import TrustsTable from "../../../../components/table/all-tables/checklisttable/TrustsTable";
import FinancialsTable from "../../../../components/table/all-tables/checklisttable/FinancialsTable";
import Questions from "../Questions/Questions";
import SelectQuestions from "../Questions/SelectQuestions";
import { useParams } from "react-router-dom";
import CreditDecisionNotes from "../Checklist-credit-decision-notes/CreditDecisionNotes";
import { checkListTab } from "../../../../locales/en";
import {
  getReportingChecklistGenerateDBURL,
  getReportingChecklistGenerateRefreshURL
} from "../../../../utils/constants/apiEndPoints";
import privateAxios from "../../../../utils/axiosPrivate";
import TableStyle from "./../../../../components/table/table.module.scss";
import styles from "./../../../../assets/scss/custom.module.scss";
import LineSkeleton from "../../../../components/skeletons/LineSkeleton";
import { showToast } from "../../../../utils/utils";

const SalesDetails = () => {
  const [sendData, setSendData] = useState();
  const { id } = useParams();
  const hasFetched = useRef(false);
  const [loading, setLoading] = useState(false);

  const dataFormDb = async () => {
    try {
      const response = await privateAxios.get(
        getReportingChecklistGenerateDBURL,
        {
          params: {
            userAccountId: id,
            isAutoFetch: false
          }
        }
      );
      setSendData(response.data.data);
    } catch {
      // handle catch here;
    }
  };

  const dataFormDbRefresh = async () => {
    setLoading(true);
    try {
      const response = await privateAxios.get(
        getReportingChecklistGenerateRefreshURL,
        {
          params: {
            userAccountId: id
          }
        }
      );
      setSendData(response.data.data);
    } catch {
      // handle catch here;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const dataFormDbAutoFetch = async () => {
      try {
        const response = await privateAxios.get(
          getReportingChecklistGenerateDBURL,
          {
            params: {
              userAccountId: id,
              isAutoFetch: true
            }
          }
        );
        setSendData(response?.data?.data);
      } catch (error) {
        showToast(error?.response?.data?.message);
      }
    };
    if (!hasFetched.current) {
      dataFormDbAutoFetch();
      hasFetched.current = true;
    }
  }, []);

  return (
    <ErrorBoundary fallback={<ComponentViewFallback />}>
      {loading ? (
        <LineSkeleton height="46px" />
      ) : (
        <>
          <div className={`${styles.titleArea} d-flex align-items-center`}>
            <div className="px-2">
              <ul
                className={`${styles.btngroupwrap} d-flex justify-content-end align-items-center`}
              >
                <h4>{checkListTab?.title}</h4>
                <li>
                  <span className={`${styles.btnPrimary} added-icon`}>
                    <button
                      className={styles.btnPrimary}
                      onClick={dataFormDbRefresh}
                    >
                      <AiOutlineReload
                        title={checkListTab?.toolTip?.refreshAllBtn}
                      />
                    </button>
                  </span>
                </li>
                <li>
                  <span className={`${styles.btnPrimary} added-icon`}>
                    <button className={styles.btnPrimary} onClick={dataFormDb}>
                      <LuDatabaseBackup
                        title={checkListTab?.toolTip?.refreshDbBtn}
                      />
                    </button>
                  </span>
                </li>
              </ul>
            </div>
          </div>
          {sendData && Object.keys(sendData).length > 0 && (
            <>
              <div className="row">
                <div className="col-12 mb-3">
                  <div className="blog-input-wrap">
                    <ErrorBoundary fallback={<ComponentViewFallback />}>
                      <ChecklistTable
                        sendData={sendData?.salesAdditionalNote}
                        userId={id}
                      />
                    </ErrorBoundary>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12 mb-3">
                  <ErrorBoundary fallback={<ComponentViewFallback />}>
                    <BusinessTable
                      salesBusinessInfo={sendData?.salesBusinessInfo}
                      userId={id}
                      salesAdditionalNote={sendData?.salesAdditionalNote}
                    />
                  </ErrorBoundary>
                </div>
                <div className="col-12 mb-3">
                  <ErrorBoundary fallback={<ComponentViewFallback />}>
                    <OwnersTable
                      salesOwnerProperty={sendData?.salesOwnerProperty}
                      userId={id}
                      salesAdditionalNote={sendData?.salesAdditionalNote}
                    />
                  </ErrorBoundary>
                </div>
                <div className="col-12 mb-3">
                  <ErrorBoundary fallback={<ComponentViewFallback />}>
                    <TrustsTable
                      trustCorporates={sendData?.trustCorporates}
                      userId={id}
                    />
                  </ErrorBoundary>
                </div>
                <div className="col-12 mb-3">
                  <ErrorBoundary fallback={<ComponentViewFallback />}>
                    <FinancialsTable
                      salesFinancialMetric={sendData?.salesFinancialMetric}
                      userId={id}
                      salesAdditionalNote={sendData?.salesAdditionalNote}
                    />
                  </ErrorBoundary>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <Table
                    className={`${TableStyle.commonCustomtable} checklist-table no-border mb-5`}
                  >
                    <thead>
                      <tr>
                        <td>{checkListTab?.creditDecisionNote}</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <div>
                            <ErrorBoundary fallback={<ComponentViewFallback />}>
                              <CreditDecisionNotes
                                userId={id}
                                salesAdditionalNote={
                                  sendData?.salesAdditionalNote
                                }
                              />
                            </ErrorBoundary>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </div>
              {/* This is for QUESTIONS: */}
              <div className="row">
                <div className="col-12 mb-3">
                  <div className="blog-input-wrap">
                    <ErrorBoundary fallback={<ComponentViewFallback />}>
                      <Questions
                        sendData={sendData?.submitedQuestion}
                        userId={id}
                      />
                    </ErrorBoundary>
                  </div>
                </div>
              </div>
              {/* This is for SELECT QUESTIONS: */}
              <div className="row">
                <div className="col-12 mb-3">
                  <div className="blog-input-wrap">
                    <ErrorBoundary fallback={<ComponentViewFallback />}>
                      <SelectQuestions
                        sendData={sendData?.allQuestions}
                        userId={id}
                        refreshData={dataFormDb}
                        setLoading={setLoading}
                      />
                    </ErrorBoundary>
                  </div>
                </div>
              </div>
            </>
          )}
        </>
      )}
    </ErrorBoundary>
  );
};

export default SalesDetails;
